import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { Env, readFromEnv } from "@cinch-nx/environments";
var STORYBLOK_BFF_URL = "".concat(readFromEnv(Env.StoryblokBFFComponent));
export var getTags = function() {
    var _ref = _async_to_generator(function() {
        var params, url, data, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = new URLSearchParams({
                        cv: Date.now().toString()
                    });
                    url = "".concat(STORYBLOK_BFF_URL, "/get-tags?").concat(params.toString());
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch(url).then(function(res) {
                            return res.json();
                        })
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        data.tags
                    ];
                case 3:
                    e = _state.sent();
                    throw new Error("get tags endpoint not working");
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getTags() {
        return _ref.apply(this, arguments);
    };
}();
